import {Component, Input, ViewChild, ViewChildren} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {
  TrustMarketplaceStatusService
} from "../../../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-new-manage-user',
  templateUrl: './new-manage-user.component.pug',
  styleUrls: ['./new-manage-user.component.scss'],
  standalone: false
})
export class NewManageUserComponent {
  @Input() memberOptions = ConstantsService.getMemberOptions();
  filteredMemberOptions :any;
  dropDownOptions = [
    { key: 2, value: $localize`Administrator` },
    { key: 3, value: $localize`Requestor` },
    { key: 4, value: $localize`Contributor` },
    { key: 5, value: $localize`Analyst` },
    { key: 0, value: $localize`None` },
  ];
  referenceOptions = [
    { key: 2, value: $localize`Administrator` },
    { key: 3, value: $localize`Requestor` },
    { key: 4, value: $localize`Contributor` },
    { key: 0, value: $localize`None` },
  ];
  integrationOptions = [
    { key: 1, value: $localize`Integration user` },
    { key: 0, value: $localize`None` },
  ];

  isValid = false;
  @Input() selectedRole = 'member';
  @Input() canEditOwner = false;

  SUBTEXT = {
    'owner': $localize`Unrestricted access to all products, organisation settings, and user management.`,
    'member': $localize`Access to one or more products.`,
    'support': $localize`Invite Xref Support staff to help with your account or troubleshoot an issue.`,
  }

  PERMISSION_BTN_TEXT = $localize`See permission details.`;

  @Input() user: any = {};
  message = '';
  @ViewChildren('userCardMenu') kebabMenus:any;
  @ViewChild('userInviteeContainer') userContainer:any;

  constructor(
    private modalRef: BsModalRef,
    private permission: PermissionsService,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
    private alertList: AlertBannerService,
  ) {}
  ngOnInit(): void {
    const role: any = this.permission.role;
    this.canEditOwner = (role?.role === 'owner' || role?.role === 'support') && this.allProductUserPermissions();
    this.fetchTrustMarketplaceStatus()
    this.filteredMemberOptions = this.memberOptions.map(option => {
      return {
        ...option,
        display_name: $localize`${option?.display_name}`
      };
    }).filter(option => !option.hide);
  }

  allProductUserPermissions() {
    return this.memberOptions.every((option) => this.permission.getUsersControlPermissionName(option.name));
  }

  titleChange(event: any) {}
  checkedChange(role) {
    if (this.selectedRole == 'member') {
      this.memberOptions = this.memberOptions.map((value) => ({
        ...value,
        selected: 'None',
      }));
    }
    this.selectedRole = role;
    this.validate();
  }

  validate() {
    if (['owner', 'support', 'member'].includes(this.selectedRole.toLowerCase()) && this.user.roles.role === 'support') {
      this.isValid = false;
      return;
    }
    if (this.selectedRole === 'member')
    {
      if(this.user?.roles.role.toLowerCase() === 'owner'){
        this.isValid = this.isNone(this.memberOptions);
      }
      else{
        this.isValid =
        this.checkSelectedValues(
          this.memberOptions,
          this.user?.roles?.products
        ) && this.isNone(this.memberOptions);
      }
    }
    else this.isValid = this.selectedRole != this.user.roles.role;
  }

  dropDownOptionSelected(event, option) {
    option.selected = event.value;
    option.key = event.key;
    const originalOption = this.memberOptions.find(opt => opt.id === option.id);
    if (originalOption) {
      originalOption.selected = event.value;
      originalOption.key = event.key;
    }
    this.validate();
  }
  closeModal() {
    this.modalRef.hide();
  }
  save() {
    this.message = 'confirm';
    this.modalRef.hide();
  }

  checkSelectedValues(array, reference) {
    return array.some((item) => {
      const refValue = reference[item.name];
      return refValue !== undefined && item.selected != refValue;
    });
  }

  isNone(array) {
    return array.some((item) => {
      return item.selected != 'None';
    });
  }

  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
        res => {
          if(res != undefined){
            const updatedOption = this.memberOptions.find(option => option.id === 4);
            if (updatedOption) {
              updatedOption.hide = !res;
            }
          }
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      );
  }

  ngAfterViewInit() {
    const container = document.querySelector('.popup-content');
    if (container) {
      container.addEventListener('scroll', this.onScroll.bind(this));
    }

  }

  ngOnDestroy() {
    const container = document.querySelector('.popup-content');
    if (container) {
      container.removeEventListener('scroll', this.onScroll.bind(this));
    }
  }

  openPermissionsPage() {
    window.open('account/permission-help', '_blank');
  }

  onScroll(): void {
    this.userContainer.nativeElement.click()
  }
}
